import React, { Component } from 'react';
import { Route, Switch, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Layout } from 'antd';
import { checkLogin, logout } from 'store/actions/index';
import { parseTotal } from 'store/reducers/cart';

// import global css w/ antd global styles
import 'App.css';
// import styles from './App.module.css'

import PrivateRoute from 'HOC/Auth/PrivateRoute';
import Toolbar from 'containers/Navigation/Toolbar/Toolbar';
import UsersPage from 'containers/Users/UsersPage';
import AdminPage from 'containers/Admin/AdminPage';
import AppUserPage from 'containers/AppUser/AppUserPage';
import ProductPage from 'containers/Product/ProductPage';
import AuthPage from 'containers/Auth/AuthPage';
import ListPage from 'containers/List/ListPage';
import LandingPage from 'containers/LandingPage/LandingPage';
import CartFooter from 'components/Cart/Footer/CartFooter';
import PromoPage from 'containers/Promo/PromoPage';
import RoomsPage from 'containers/Rooms/RoomsPage';
import ProductTypePage from 'containers/ProductType/ProductTypePage';
import QRcodePage from './containers/QRcode/QRcodePage';
import InventoryPage from './containers/Inventory/InventoryPage';
import SettingPage from 'containers/Setting/index';
import { getSettings } from 'store/actions/setting';

const { Content } = Layout;

class App extends Component {
  componentDidMount() {
    this.props.checkLogin();
  }

  // get settings after login
  componentDidUpdate(prevProps) {
    if (this.props.isLoggedIn && !prevProps.isLoggedIn) {
      this.props.getSettings();
    }
  }

  render() {
    const { isLoggedIn } = this.props;
    const layoutStyle = this.props.location.pathname !== '/' && this.props.showCart ? { marginBottom: '79px' } : {};

    return (
      <Layout style={layoutStyle}>
        <Toolbar logout={this.props.logout} />
        <Content>
          <Switch>
            <PrivateRoute path="/rooms" exact component={RoomsPage} auth={isLoggedIn} />
            <PrivateRoute path="/lists" exact component={ListPage} auth={isLoggedIn} />
            <PrivateRoute path="/qr_codes" exact component={QRcodePage} auth={isLoggedIn} />
            <PrivateRoute path="/products" exact component={ProductPage} auth={isLoggedIn} />
            <PrivateRoute path="/users" exact component={UsersPage} auth={isLoggedIn} />
            <PrivateRoute path="/admins" exact component={AdminPage} auth={isLoggedIn} />
            <PrivateRoute path="/app_users" exact component={AppUserPage} auth={isLoggedIn} />
            <PrivateRoute path="/promotions" exact component={PromoPage} auth={isLoggedIn} />
            <PrivateRoute path="/product_types" exact component={ProductTypePage} auth={isLoggedIn} />
            <PrivateRoute path="/inventory" exact component={InventoryPage} auth={isLoggedIn} />
            <PrivateRoute path="/settings" exact component={SettingPage} auth={isLoggedIn} />
            <Route path="/login" exact component={AuthPage} />
            <Route path="/" component={LandingPage} />
          </Switch>
        </Content>
        {this.props.showCart ? <CartFooter /> : null}
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  const { authenticated } = state.auth;
  const isLoggedIn = authenticated;
  const { cart } = state;
  const showCart = parseTotal(cart) > 0 && isLoggedIn;
  return { isLoggedIn, showCart, settings: state.setting.settings };
};

export default withRouter(connect(mapStateToProps, { checkLogin, logout, getSettings })(App));



// WEBPACK FOOTER //
// ./src/App.js